<template>
    <!-- Inner content -->
    <div class="inner-content">
        <section>
            <div class="container-fluid">
                <div class="row m-0">
                    <div class="col-12">
                        <div class="card">
                            <div
                                class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative">
                                <div class="content-card-left">
                                    <h4 class="card-title text-white">Add Payment via Company</h4>
                                    <p class="fw-light text-white mb-0 pt-1">
                                        Record payments for multiple shops against one company
                                    </p>
                                </div>
                            </div>
                            <div class="card-body px-0">
                                <div class="header-content">
                                    <Form @submit="onSubmit" :validation-schema="schema"
                                        class="custom-form mt-2 shops-product" ref="myForm">
                                        <!-- Salesman -->
                                        <div class="row mx-0 px-4">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <div class="position-relative form-group">
                                                    <Field as="select" name="salesman_id"
                                                        class="form-select custom-select" @click="selectFocus = true"
                                                        v-model="salesman_id">
                                                        <option value="0">Choose Salesman</option>
                                                        <option v-for="salesman in salesmen" :value="salesman.id"
                                                            :key="salesman.id">{{ salesman.first_name + " " +
                                                                salesman.last_name }}</option>
                                                    </Field>
                                                    <label
                                                        :class="[selectFocus ? 'focus' : '', 'position-absolute select-label']">Salesman</label>
                                                    <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                    <ErrorMessage class="invalid-message mb-0 pt-2"
                                                        name="salesman_id" />
                                                    <p v-if="errors_v.get('salesman_id')"
                                                        class="invalid-message mb-0 pt-2">
                                                        {{ errors_v.get('salesman_id') }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Company -->
                                        <div class="row mx-0 px-4 mt-4">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <Multiselect v-model="company_id" :options="companyOptions"
                                                    class="custom-multiselect" placeholder="Company" :searchable="true"
                                                    :showOptions="true" mode="single" label="name" trackBy="name"
                                                    valueProp="id" />
                                                <Field type="hidden" name="company_id" v-model="company_id" />
                                                <p v-if="errors_v.get('company_id')"
                                                    class="invalid-message mb-0 pt-2">
                                                    {{ errors_v.get('company_id') }}
                                                </p>
                                                <ErrorMessage class="invalid-message mb-0 pt-2" name="company_id" />
                                            </div>
                                        </div>
                                        <!-- Payment date: today or up to 3 days back -->
                                        <div class="row mx-0 px-4 mt-4">
                                            <div class="col-lg-11 col-md-11 col-sm-10 col-9">
                                                <div class="position-relative form-group">
                                                    <select class="form-select custom-select"
                                                        @click="dateFocus = true" v-model="payment_date">
                                                        <option v-for="opt in dateOptions" :key="opt.value"
                                                            :value="opt.value">{{ opt.label }}</option>
                                                    </select>
                                                    <label
                                                        :class="[dateFocus ? 'focus' : '', 'position-absolute select-label']">Payment
                                                        Date</label>
                                                    <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                                                    <p v-if="errors_v.get('date')" class="invalid-message mb-0 pt-2">
                                                        {{ errors_v.get('date') }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Shop rows -->
                                        <fieldset class="InputGroup row mx-0" v-for="(shop, idx) in shops"
                                            :key="shop.id">
                                            <div class="row mx-0 shop-row mt-4 pt-3 pb-4">
                                                <div class="col-12 px-0">
                                                    <div class="row mx-0 px-4">
                                                        <div class="col-12" v-if="idx === 0">
                                                            <div class="d-flex flex-wrap align-items-center mb-2">
                                                                <h6 class="mb-0 text-primary">Shop#{{ idx + 1 }}</h6>
                                                                <div class="text-center add-rows-wrapper ms-auto">
                                                                    <span
                                                                        class="d-inline-block add bi bi-plus-circle-fill text-primary"
                                                                        @click="add_shop"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12" v-else>
                                                            <div class="d-flex flex-wrap align-items-center mb-2">
                                                                <h6 class="mb-0 text-primary">Shop#{{ idx + 1 }}</h6>
                                                                <div class="text-center add-rows-wrapper ms-auto">
                                                                    <span
                                                                        class="d-inline-block add bi bi-dash-circle-fill text-primary"
                                                                        @click="remove_shop(shop)"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-5 col-md-5 mb-lg-0 mb-md-0 mb-3 col-12">
                                                            <Multiselect
                                                                @select="changeMultiselectShop(shop.shop_model, idx)"
                                                                v-model="shop.shop_model" :options="shopOptions"
                                                                class="custom-multiselect" placeholder="Shop"
                                                                :searchable="true" :showOptions="true" mode="single"
                                                                label="shopName" trackBy="shop_name" valueProp="id"
                                                                :id="`multiselect_${idx}`"
                                                                :name="`shops[${idx}].multiselect`" />
                                                            <Field type="hidden" :id="`shopid_${idx}`"
                                                                :name="`shops[${idx}].shopid`"
                                                                v-model="values_hidden_shops[idx]" />
                                                            <p v-if="errors_v.get('paymentData.' + idx + '.shop_id')"
                                                                class="invalid-message mb-0 pt-2">
                                                                {{ errors_v.get('paymentData.' + idx + '.shop_id') }}
                                                            </p>
                                                            <ErrorMessage class="invalid-message mb-0 pt-2"
                                                                :name="`shops[${idx}].shopid`" />
                                                        </div>
                                                        <div class="col-lg-3 col-md-3 mb-lg-0 mb-md-0 mb-3 col-12">
                                                            <div class="position-relative">
                                                                <Field type="number" :id="`amount_${idx}`"
                                                                    :name="`shops[${idx}].amount`"
                                                                    :class="[shop.amount == '' ? '' : 'active', 'border-input position-relative w-100']"
                                                                    v-model="shop.amount" />
                                                                <label for=""
                                                                    class="mb-0 placeholder-label w-auto">Amount</label>
                                                                <p v-if="errors_v.get('paymentData.' + idx + '.amount')"
                                                                    class="invalid-message mb-0 pt-2">
                                                                    {{ errors_v.get('paymentData.' + idx + '.amount') }}
                                                                </p>
                                                                <ErrorMessage class="invalid-message mb-0 pt-2"
                                                                    :name="`shops[${idx}].amount`" />
                                                            </div>
                                                        </div>
                                                        <div class="col-12 mb-lg-0 mb-md-0 mb-3">
                                                            <div class="position-relative">
                                                                <label :for="`paymentType_${idx}`"
                                                                    class="mb-1 d-block text-muted small">Payment Type</label>
                                                                <Field as="textarea" rows="3" :id="`paymentType_${idx}`"
                                                                    :name="`shops[${idx}].paymentType`"
                                                                    class="border-input textarea-input w-100"
                                                                    placeholder="Enter payment details"
                                                                    v-model="shop.paymentType" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div class="card-footer px-4 pb-0 border-0 bg-transparent mb-3">
                                            <button class="btn btn-primary w-100" :disabled="loader">
                                                <div v-if="loader" class="spinner-border me-2" role="status"></div>
                                                Add Payment
                                            </button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { ref, reactive, onMounted, watch } from 'vue';
import moment from 'moment';
import "@/assets/scss/pages/_add-billing.scss";
import Multiselect from '@vueform/multiselect';
import "@vueform/multiselect/themes/default.css";
import salesmanServices from '@/services/SalesmanServices';
import salesmanShopServices from '@/services/SalesmanShopServices';
import CompanyServices from '@/services/CompanyServices';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Errors from "@/utils/Errors";
import * as yup from "yup";
import { useRouter } from "vue-router";
import balanceSheetServices from '@/services/BalanceSheetServices';
export default {
    components: {
        Multiselect,
        Form,
        Field,
        ErrorMessage
    },
    setup() {
        const salesmen = ref([]);
        const salesman_id = ref(0);
        const company_id = ref(null);
        const companyOptions = ref([]);
        const shopOptions = ref([]);
        const loader = ref(false);
        const router = useRouter();
        const selectFocus = ref(false);
        const dateFocus = ref(false);
        // Payment date can only be one of the last 4 dates (today + previous 3 days).
        const dateOptions = [0, 1, 2, 3].map((i) => {
            const d = moment().subtract(i, 'days');
            return { value: d.format('YYYY-MM-DD'), label: d.format('DD/MM/YY') + (i === 0 ? ' (Today)' : '') };
        });
        const payment_date = ref(dateOptions[0].value);
        const errors_v = reactive(new Errors());
        const values_hidden_shops = ref({});
        const shops = ref([{
            id: Date.now(),
            shop_model: "",
            amount: "",
            paymentType: ""
        }]);
        const schema = yup.object().shape({
            salesman_id: yup.number().moreThan(0, 'Salesman Required'),
            company_id: yup.string().required('Company Required').typeError('Company Required'),
            shops: yup
                .array()
                .of(
                    yup.object().shape({
                        shopid: yup.number().required().label("Shop Name"),
                        amount: yup.number().moreThan(0, 'Amount Required').typeError("Only Numbers Allowed").label("Amount"),
                    })
                )
        });
        const add_shop = () => {
            shops.value.push({
                id: Date.now(),
                shop_model: "",
                amount: "",
                paymentType: ""
            });
        }
        const remove_shop = (item) => {
            const index = shops.value.indexOf(item);
            if (index === -1) {
                return;
            }
            shops.value.splice(index, 1);
            values_hidden_shops.value = {};
            shops.value.forEach((s, i) => {
                values_hidden_shops.value[i] = s.shop_model;
            });
        }
        async function changeMultiselectShop(value, idx) {
            values_hidden_shops.value[idx] = value;
        }
        function resetCustomForm() {
            shops.value = [{
                id: Date.now(),
                shop_model: "",
                amount: "",
                paymentType: ""
            }];
            values_hidden_shops.value = {};
        }
        watch(() => salesman_id.value, (currentValue, oldValue) => {
            if (currentValue != oldValue && currentValue != "") {
                salesmanShopServices.getSalesmanShops(salesman_id.value)
                    .then(response => {
                        shopOptions.value = response.data.data;
                    });
                resetCustomForm();
            }
        });
        onMounted(async () => {
            await salesmanServices.paginateSalesman()
                .then(response => {
                    salesmen.value = response.data.data;
                });
            await CompanyServices.paginateCompanies()
                .then(response => {
                    companyOptions.value = response.data.data || [];
                });
        });
        const onSubmit = async (values, actions) => {
            loader.value = true;
            const payload = {
                salesman_id: values.salesman_id,
                company_id: company_id.value,
                date: payment_date.value,
                paymentData: values.shops.map(s => ({
                    shop_id: s.shopid,
                    amount: s.amount,
                    type: (s.paymentType && s.paymentType !== "") ? s.paymentType : 'Payment via company'
                }))
            };
            await balanceSheetServices.addPaymentViaCompany(payload)
                .then(() => {
                    resetCustomForm();
                    loader.value = false;
                    actions.resetForm();
                    router.push('/balancesheet/shop');
                })
                .catch(error => {
                    loader.value = false;
                    if (error.response && error.response.status == 422) {
                        errors_v.record(error.response.data.errors);
                    } else {
                        const msg = (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Unable to add payment';
                        alert(msg);
                    }
                });
        }
        return {
            selectFocus,
            dateFocus,
            dateOptions,
            payment_date,
            shops,
            add_shop,
            remove_shop,
            changeMultiselectShop,
            salesmen,
            salesman_id,
            company_id,
            companyOptions,
            shopOptions,
            onSubmit,
            values_hidden_shops,
            errors_v,
            schema,
            resetCustomForm,
            loader,
            router
        }
    }
}
</script>
